<template>
  <div id="adminSettingNews">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Admin / Contenuti</li>
      <li class="breadcrumb-item active">
        <router-link :to="url" v-on:click.native="cancelNewNews">
          Blog
        </router-link>
      </li>
      <li
        style="
          float: right;
          position: absolute;
          right: 15px;
          float: right;
          position: absolute;
          right: 15px;
          font-weight: bold;
          font-size: 20px;
          color: #303c54;
          text-transform: uppercase;
          margin-top: -5px;
        "
      >
        {{ titoloPagina }}
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <div class="row">
  <div class="col-6">
      <h1>Blog</h1>
      </div>
      <div class="col-6" style="text-align: right;padding-right: 30px;" v-if="detailOrNew">
        <button
                  id="btnCancelNew"
                  type="button"
                  class="btn btn-danger"
                  @click="cancelNewNews"
                >
                  <i class="fa fa-times"></i>
                  <span>{{ cancel }}</span>
                </button>
                <button id="btnAddNew" type="button" class="btn btn-success" @click="savePage()">
                  <i class="fa fa-floppy-o"></i>
                  <span> {{ save }}</span>
                </button>
                 <button id="btnAddNew" type="button" class="btn btn-success" @click="savePageAndExit()">
                  <i class="fa fa-floppy-o"></i>
                  <span> Salva ed Esci</span>
                </button>
    </div>

      </div>
    </div>
   
    <div class="container-fluid">
      <div class="card" style="background:transparent;border:0px;">
        <div class="tab-content noborder" style="background:transparent;">
          <div id="tabAdminSettingNews" class="tab-pane nopadding active" role="tabpanel" style="background:#fff;">
            <div class="card-body card-body-table">
              <div class>
                <div class="active" id="tabNewsBody" role="tabpanel">
                  <div class="row align-btns" style="width: 85%;">
                    <div class="col-lg-6">
                      <button id="btnAdd" type="button" class="btn btn-primary" @click="onClickNew">
                        <i class="fa fa-plus"></i>
                        <span>{{ add }}</span>
                      </button>
                    </div>
                    <label style="margin-top: 8px;">Lingua</label>
                    <div class="col-3 text-left" style="margin-top: 4px;"> 
                      <select2
                        id="select_AdminPagesView_IdLanguage"
                        ref="select_AdminPagesView_IdLanguage"
                        style="width:75%"
                        :filterable="false"
                        service="languages"
                        v-model="
                          pageValueSelected.languagePageSetting.idLanguage
                        "
                        :default="defaultLanguageOptions"
                        :change="languageChange"
                      />
                     
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                      <bootstrapTable
                        :configurations="tableNewsConfiguration"
                        :datas="tableNewsData"
                        id="tableNews"
                        ref="tableNews"
                        :results="tableNewsResult"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="tabNewNewsBody" role="tabpanel" style="background:transparent;box-shadow: none !important;margin-top:-18px;">
            <div class="row">
              <div
                id="divContentAdminPagesView"
                class="col-sm-12 nopadding"
                style="transition: all 0.5s ease-in-out;"
              >
                <!-- <div class="card"> -->
                <div class="card-body nopadding" style="padding: 1.25rem;">
                  <div class="container-fluid nopadding">
                    <div class="row" style="margin:0px;">
                      <div class="col-9" style="transition: all 0.5s ease-in-out;">
                        <div id="pageContentAdminPagesView">
                          <div class="row">
                            <FroalaEditor
                              :content="
                                pageValueSelected.languagePageSetting.content
                              "
                              v-on:updateContenuto="updateContenuto"
                              :tipoTemplate="tipoTemplate"
                            ></FroalaEditor>
                          </div>
                          <div class="row">&nbsp;</div>
                          <div class="row" v-if="showJS">
                            <div class="col nopadding">
                              <label>Javascript</label>
                              <codemirror
                                v-model="pageValueSelected.js"
                                :options="cmOptions"
                                style="border: solid 1px;"
                              ></codemirror>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3" style="transition: all 0.5s ease-in-out;margin-top: 10px;">
                        <div id="pageSettingAdminPagesView">
                          <pageDetail
                            functions="adminSettingNews"
                            :configurations="detailConfigurations"
                            :jsonValue="pageValueSelected"
                          ></pageDetail>
                        </div>
                        <div id="accordion" style="background:#fff;">
                          <div>
                            <div class="card-header" id="headingOne">
                              <i class="nav-icon fa fa-tags"></i>&nbsp;
                              <h5 class="mb-0 pl-0 ml-0">
                                <button
                                  class="btn btn-link"
                                  data-toggle="collapse"
                                  data-target="#collapseOne"
                                  aria-expanded="true"
                                  aria-controls="collapseOne"
                                >ATTRIBUTI</button>
                              </h5>
                            </div>

                            <div
                              id="collapseOne"
                              class="collapse show"
                              aria-labelledby="headingOne"
                              data-parent="#accordion"
                            >
                              <div class="card-body">
                                <div id="pageTabAttribute">
                                  <!-- v-visible="pageToView == 'settings'" -->
                                  <pageDetail
                                    functions="adminSettingNews"
                                    :configurations="TabAttributeConfigurations"
                                    :jsonValue="pageValueSelected"
                                  ></pageDetail>

                             <!-- upload img cover ---->  
                                <div class="row">             
                                  <div class="col-12">
                                    <label class="col col-form-label nopadding label-effect" id="col-form-label">Immagine in evidenza</label>
                                    <button
                                      class="btn btn-primary mt-2"
                                      @click="getImage(pageImage)"
                                    >
                                      Seleziona
                                    </button>
                                  </div>  
                                  <div class="col-12 my-2">
                                    <img style="max-width:100%; height:auto; max-height: 100px;" :src="pageValueSelected.languagePageSetting.urlCoverImage">
                                  </div>
                                </div>
                          
                                <div class="row">    
                                  <div class="col-12">
                                    <label
                                      id="move-file"
                                      v-cloak
                                      @drop.prevent="handleFileInput"
                                      @dragover.prevent
                                      class="custom-file-upload"
                                      style="padding: 50px; width:100%;"
                                    >
                                      <input
                                        id="imgAggUpload"
                                        type="file"
                                        name="file-input"
                                        multiple="True"
                                        @change="handleFileInput"
                                      />
                                      SFOGLIA / UPLOAD AREA
                                    </label>
                                  </div>
                                </div>
                                <!-- end upload img---->      
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div class="card-header" id="headingTwo">
                              <i class="nav-icon fa fa-compass"></i>&nbsp;
                              <h5 class="mb-0 pl-0 ml-0">
                                <button
                                  class="btn btn-link collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseTwo"
                                  aria-expanded="false"
                                  aria-controls="collapseTwo"
                                >PUBBLICAZIONE</button>
                              </h5>
                            </div>
                            <div
                              id="collapseTwo"
                              class="collapse"
                              aria-labelledby="headingTwo"
                              data-parent="#accordion"
                            >
                              <div class="card-body">
                                <div id="pageTabPublication">
                                  <div id="pageTabPublicationCat">
                                    <label id="titlePageTabPublication">Categorie</label>
                                    <div class="row">
                                      <div class="col-12">
                                       <treeCategories
                                        :listCategories="listTreeCategories"
                                      ></treeCategories>

                                        <!--<div class="cont-page-categories" v-for="pageCategorys in pageCategory" :key="pageCategorys.id">
                                          <input type="checkbox" @change="updatePageCategory(pageCategorys.id)" :id="'checkboxPageCategories' + pageCategorys.id" class="checkboxPageCategories" checked="checked" v-if="pageCategorys.active">
                                          <input type="checkbox" @change="updatePageCategory(pageCategorys.id)" :id="'checkboxPageCategories' + pageCategorys.id" class="checkboxPageCategories" v-else>
                                          <label class="labelPageCategories">{{pageCategorys.description}}</label>
                                        </div> --->
                                      </div>
                                    </div>
                                  </div>
                                  <!-- select autore login utente -->
                                  <div class="row">
                                     <div class="col-12">
                                    <label>Autore</label><br>
                                    <select class="custom-select user_id" style="width:100%!important;" id="user_id" name="user_id"></select>
                                  </div>
                                </div>

                                  <!-- v-visible="pageToView == 'settings'" -->
                                    <pageDetail
                                    functions="adminSettingNews"
                                    :configurations="
                                      TabPublicationConfigurations
                                    "
                                    :jsonValue="pageValueSelected"
                                  ></pageDetail>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div class="card-header" id="headingThree">
                              <i class="nav-icon fa fa-share-square-o"></i>&nbsp;
                              <h5 class="mb-0 pl-0 ml-0">
                                <button
                                  class="btn btn-link collapsed"
                                  data-toggle="collapse"
                                  data-target="#collapseThree"
                                  aria-expanded="false"
                                  aria-controls="collapseThree"
                                >SOCIAL SHARE</button>
                              </h5>
                            </div>
                            <div
                              id="collapseThree"
                              class="collapse"
                              aria-labelledby="headingThree"
                              data-parent="#accordion"
                            >
                              <div class="card-body">
                                <div id="pageTabSocialShare">
                                  <!-- v-visible="pageToView == 'settings'" -->
                                  <pageDetail
                                    functions="adminSettingNews"
                                    :configurations="
                                      TabSocialShareConfigurations
                                    "
                                    :jsonValue="pageValueSelected"
                                  ></pageDetail>

                                  <!-- upload share img ---->  
                                <div class="row">             
                                  <div class="col-12">
                                    <label class="col col-form-label nopadding label-effect" id="col-form-label">Immagine di condivisione</label>
                                    <button
                                      class="btn btn-primary mt-2"
                                      @click="getImageShare(pageImageShare)"
                                    >
                                      Seleziona
                                    </button>
                                  </div>  
                                  <div class="col-12 my-2">
                                    <img style="max-width:100%; height:auto; max-height: 100px;" :src="pageValueSelected.languagePageSetting.urlShareImage">
                                  </div>
                                </div>
                          
                                <div class="row">    
                                  <div class="col-12">
                                    <label
                                      id="move-file"
                                      v-cloak
                                      @drop.prevent="handleFileInputShare"
                                      @dragover.prevent
                                      class="custom-file-upload"
                                      style="padding: 50px; width:100%;"
                                    >
                                      <input
                                        id="imgAggUpload"
                                        type="file"
                                        name="file-input"
                                        multiple="True"
                                        @change="handleFileInputShare"
                                      />
                                      SFOGLIA/UPLOAD AREA
                                    </label>
                                  </div>
                                </div>
                                <!-- end upload share img----> 

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-right" style="margin-top:15px;">
                <button
                  id="btnCancelNew"
                  type="button"
                  class="btn btn-danger"
                  @click="cancelNewNews"
                >
                  <i class="fa fa-times"></i>
                  <span>{{ cancel }}</span>
                </button>
                <button id="btnAddNew" type="button" class="btn btn-success" @click="savePage()">
                  <i class="fa fa-floppy-o"></i>
                  <span> {{ save }}</span>
                </button>
                 <button id="btnAddNew" type="button" class="btn btn-success" @click="savePageAndExit()">
                  <i class="fa fa-floppy-o"></i>
                  <span> Salva ed Esci</span>
                </button>
              </div>
            </div>
          </div>
   <!-- modal immagini -->
                  <div
                    class="modal"
                    id="modalImgBlogForm"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialo popup" role="document">
                      <div class="modal-content modal">
                        <div class="modal-header text-center">
                          

                          <div class="row" style="width:100%;">
                            <div class="col-4 text-left"> 
                              <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagini</h2>
                            </div>
                            <div class="col-2 text-right">
                            <select class="form-control" id="month" name="month" @change="Search()">
                              <option value="">Mese</option>
                              <option value="01">Gennaio</option>
                              <option value="02">Febbraio</option>
                              <option value="03">Marzo</option>
                              <option value="04">Aprile</option>
                              <option value="05">Maggio</option>
                              <option value="06">Giugno</option>
                              <option value="07">Luglio</option>
                              <option value="08">Agosto</option>
                              <option value="09">Settembre</option>
                              <option value="10">Ottobre</option>
                              <option value="11">Novembre</option>
                              <option value="12">Dicembre</option>
                            </select>
                          </div>
                          <div class="col-2 text-right">
                            <select class="form-control" id="year" name="year" @change="Search()">
                              <option value="">Anno</option>
                              <option value="2025">2025</option>
                              <option value="2024">2024</option>
                              <option value="2023">2023</option>
                              <option value="2022">2022</option>
                              <option value="2021">2021</option>
                              <option value="2020">2020</option>
                              <option value="2019">2019</option>
                              <option value="2018">2018</option>
                              <option value="2017">2017</option>
                              <option value="2016">2016</option>
                              <option value="2015">2015</option>
                              <option value="2014">2014</option>
                              <option value="2013">2013</option>
                              <option value="2012">2012</option>
                              <option value="2011">2011</option>
                              <option value="2010">2010</option>
                            </select>
                          </div>
                            <div class="col-4"> 
                              <input type="text" class="form-control" id="search" required="required" name="search" placeholder="Cerca" @keyup="Search()"/> 
                            </div>
                          </div>

                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"

                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body mx-3">
                          <div class="md-form mb-5">
                            <div
                              class="row">
                              <ul class="list-group" id="ul-image" @scroll="handleScroll">
                              <li class="listLi" v-for="resultFilePopup in resultFilePopups" v-bind:key="resultFilePopup.id" @click="
                                selectImg(
                                resultFilePopup.img,
                                resultFilePopup.imgName)" >
                                <div class="list-group-item" v-if="resultFilePopup.visible" :style="'cursor:pointer;position: relative;min-width:110px;min-height:110px;min-width:110px;max-width:110px;background-size:cover;background-image:url(\'' + resultFilePopup.img + '\')'">
                                  <div v-if="resultFilePopup.ext!=''" class="div-extension-img">
                                    <label>{{ resultFilePopup.ext }}</label>
                                  </div>
                                  <label class="labelListImage">{{ resultFilePopup.imgName }}</label>
                                </div>
                                </li> 
                            </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end modal immagini -->
                  <!-- modal immagini share -->
                  <div
                    class="modal"
                    id="modalImgBlogFormShare"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialo popup" role="document">
                      <div class="modal-content modal">
                        <div class="modal-header text-center">
                          

                          <div class="row" style="width:100%;">
                            <div class="col-4 text-left"> 
                              <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagini</h2>
                            </div>
                            <div class="col-2 text-right">
                            <select class="form-control" id="monthShare" name="monthShare" @change="SearchShare()">
                              <option value="">Mese</option>
                              <option value="01">Gennaio</option>
                              <option value="02">Febbraio</option>
                              <option value="03">Marzo</option>
                              <option value="04">Aprile</option>
                              <option value="05">Maggio</option>
                              <option value="06">Giugno</option>
                              <option value="07">Luglio</option>
                              <option value="08">Agosto</option>
                              <option value="09">Settembre</option>
                              <option value="10">Ottobre</option>
                              <option value="11">Novembre</option>
                              <option value="12">Dicembre</option>
                            </select>
                          </div>
                          <div class="col-2 text-right">
                            <select class="form-control" id="yearShare" name="yearShare" @change="SearchShare()">
                              <option value="">Anno</option>
                              <option value="2025">2025</option>
                              <option value="2024">2024</option>
                              <option value="2023">2023</option>
                              <option value="2022">2022</option>
                              <option value="2021">2021</option>
                              <option value="2020">2020</option>
                              <option value="2019">2019</option>
                              <option value="2018">2018</option>
                              <option value="2017">2017</option>
                              <option value="2016">2016</option>
                              <option value="2015">2015</option>
                              <option value="2014">2014</option>
                              <option value="2013">2013</option>
                              <option value="2012">2012</option>
                              <option value="2011">2011</option>
                              <option value="2010">2010</option>
                            </select>
                          </div>
                            <div class="col-4"> 
                              <input type="text" class="form-control" id="searchShare" required="required" name="searchShare" placeholder="Cerca" @keyup="SearchShare()"/> 
                            </div>
                          </div>

                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body mx-3">
                          <div class="md-form mb-5">
                            <div
                              class="row">
                              <ul class="list-group" id="ul-image-share" @scroll="handleScrollShare">
                              <li class="listLi" v-for="resultFilePopup in resultFilePopupsShare" v-bind:key="resultFilePopup.id" @click="
                                selectImgShare(
                                resultFilePopup.img,
                                resultFilePopup.imgName)" >
                                <div class="list-group-item" v-if="resultFilePopup.visible" :style="'cursor:pointer;position: relative;min-width:110px;min-height:110px;min-width:110px;max-width:110px;background-size:cover;background-image:url(\'' + resultFilePopup.img + '\')'">
                                  <div v-if="resultFilePopup.ext!=''" class="div-extension-img">
                                    <label>{{ resultFilePopup.ext }}</label>
                                  </div>
                                  <label class="labelListImage">{{ resultFilePopup.imgName }}</label>
                                </div>
                                </li> 
                            </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end modal immagini share -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";
import BootstrapTable from "@/components/BootstrapTable.vue";
import FroalaEditor from "@/components/FroalaEditor.vue";
import TreeCategories from "@/components/TreeCategories.vue";
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";

export default {
  name: "adminSettingNews",
  components: {
    codemirror,
    Select2,
    BootstrapTable,
    PageDetail,
    FroalaEditor,
    TreeCategories,
  },
  data() {
    return {
      cmOptions: {
        indentWithTabs: true,
        line: true,
        lineNumbers: true,
        lineWrapping: true,
        mode: "text/css",
        tabMode: "indent",
        tabSize: 4,
      },
      tipoTemplate: "Blog",
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      del: dictionaryHelpers.getDictionary("Delete"),
      save: dictionaryHelpers.getDictionary("Save"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      news: dictionaryHelpers.getDictionary("News"),
      blog: dictionaryHelpers.getDictionary("Blog"),
      save: dictionaryHelpers.getDictionary("Save"),
      newTitle: dictionaryHelpers.getDictionary("NewBlog"),
      newNews: dictionaryHelpers.getDictionary("NewNews"),
      newBlog: dictionaryHelpers.getDictionary("NewBlog"),
      pageSetting: dictionaryHelpers.getDictionary("PageSetting"),
      preview: dictionaryHelpers.getDictionary("Preview"),
      content: dictionaryHelpers.getDictionary("Content"),
      language: dictionaryHelpers.getDictionary("Language"),
      TabAttributeConfigurations: [],
      TabPublicationConfigurations: [],
      TabSocialShareConfigurations: [],
      tableNewsConfiguration: [],
      configurationsSettings: [],
      pageCategory:[],
      resultFilePopups: [],
      resultFilePopupsShare: [],
      files: [],
      defaultLanguageOptions: [],
      listTreeCategories: [],
      pageToView: "content",
      typePage: "",
      detailConfigurations: [],
      configurationsSelected: [],
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null, imgName: null},
        online: true,
      },
      pageValueOriginal: {},
      pageValueDataToSave: {},
      tableNewsData: [],
      tableNewsResult: [],
      idTabAdminSettingNews: "tabAdminSettingNews",
      idTabNewNewsBody: "tabNewNewsBody",
      url: window.location.pathname,
      disableButton: true,
      showJS: false,
      img:'',
      name: '',
      titoloPagina: "",
      visible:true,
      detailOrNew:false,
      pageImage: 1,
      pageImageShare: 1
    };
  },
  mounted() {
    var adminSettingNews = this;

    languageServices.select("*", function (result) {
      if (result.data.length == 1) {
        adminSettingNews.divLanguage = false;
      } else {
        adminSettingNews.divLanguage = true;
      }
    });
  },
  created() {
    var adminSettingNews = this;
    spinnerHelpers.show();
    adminSettingNews.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage(),
    };

    this.loadConfiguration();
  },
  watch: {
    "pageValueSelected.enableJS": function (newVal, oldVal) {
      this.showJS = newVal;
    },
  },
  methods: {
    loadConfiguration() {
      var adminSettingNews = this;
    
      adminConfigurationServices.getFunctionality(function (result) {
        if (
          functionHelpers.isValued(result) &&
          functionHelpers.isValued(result.data) &&
          functionHelpers.isValued(result.data)
        ) {
          adminSettingNews.configurations = result.data;
          adminSettingNews.tableNewsConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
          $.each(adminSettingNews.configurations.tabsConfigurations, function (
            i,
            configuration
          ) {
            switch (configuration.code) {
              case "Settings":
              
                adminSettingNews.detailConfigurations =
                  configuration.pageConfigurations;
                break;
              case "TabAttribute":
                adminSettingNews.TabAttributeConfigurations = configuration.pageConfigurations;
                break;
              case "TabPublication":
                adminSettingNews.TabPublicationConfigurations =
                  configuration.pageConfigurations;
                break;
              case "TabSocialShare":
                adminSettingNews.TabSocialShareConfigurations =
                  configuration.pageConfigurations;
                break;
            }
          });

          $.each(adminSettingNews.detailConfigurations, function (
            i,
            configuration
          ) {
            if (configuration.field == "password") {
              configuration.required = true;
            }
          });
        }

        $.each(adminSettingNews.configurationsSettings, function (i, config) {
          if (config.field == "PageType") {
            adminSettingNews.pageValueSelected.pageType = "Blog";
            adminSettingNews.pageValueOriginal.pageType = "Blog";
          }
        });

        adminSettingNews.loadTableData(storageData.sIdLanguage(), "Blog");
        adminSettingNews.changeView("btnContentAdminPagesView");
      });
      spinnerHelpers.hide();
    },

    loadTableData(ln, pageType) {
      var adminSettingNews = this;
      var ln = ln;
      // var pageType = pageType;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      adminSettingNews.typePage = pageType;
      if (!functionHelpers.isValued(pageType)) {
        pageType = "Blog";
        adminSettingNews.typePage = "Blog";
      }
      pageServices.getMenuList(ln, pageType, function (result) {
        spinnerHelpers.show();
        adminSettingNews.tableNewsData = result.data.pageList;
        spinnerHelpers.hide();
      });
    },

    onTabNews() {
      var adminSettingNews = this;
      adminSettingNews.newTitle = adminSettingNews.newNews;
      var ln =
        adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      adminSettingNews.loadTableData(ln, "Blog");
    },
    onTabBlog() {
      var adminSettingNews = this;
      adminSettingNews.newTitle = adminSettingNews.newBlog;
      var ln =
        adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      adminSettingNews.loadTableData(ln, "Blog");
    },

     handleFileInput(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createImgAgg(e.target.id, files[i].name, files[i]);
      }
    },

    handleFileInputShare(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createImgAggShare(e.target.id, files[i].name, files[i]);
      }
    },

  createImgAgg(id, name, file) {
      var adminSettingNews = this;
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        var jsonImgUpload = {};
        jsonImgUpload["id"] = adminSettingNews.cont + 1;
        adminSettingNews.cont = adminSettingNews.cont + 1;
        jsonImgUpload["name"] = name;
        jsonImgUpload["size"] = "0";
        jsonImgUpload["base64"] = e.target.result;
        adminSettingNews.pageValueSelected.languagePageSetting.imgName = name;
        adminSettingNews.pageValueSelected.languagePageSetting.urlCoverImage =  e.target.result;
        adminSettingNews.files.push(jsonImgUpload);
      };
      reader.readAsDataURL(file);
    },

    createImgAggShare(id, name, file) {
      var adminSettingNews = this;
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        var jsonImgUpload = {};
        jsonImgUpload["id"] = adminSettingNews.cont + 1;
        adminSettingNews.cont = adminSettingNews.cont + 1;
        jsonImgUpload["name"] = name;
        jsonImgUpload["size"] = "0";
        jsonImgUpload["base64"] = e.target.result;
        adminSettingNews.pageValueSelected.languagePageSetting.imgNameShare = name;
        adminSettingNews.pageValueSelected.languagePageSetting.urlShareImage =  e.target.result;
        adminSettingNews.files.push(jsonImgUpload);
      };
      reader.readAsDataURL(file);
    },


    onClickNew() {
      var adminSettingNews = this;
     //adminSettingNews.idUser = "";
     this.detailOrNew = true;

    adminSettingNews.titoloPagina = "";
    adminSettingNews.listTreeCategories ="";
    adminSettingNews.getPageCategory(0);
  
    $('#languagePageSetting_seoTitle_feedback').remove();
    $('#languagePageSetting_seoDescription_feedback').remove();
   // $('#languagePageSetting_SeoKeyword_feedback').remove();

    $('#titlePageTabPublication').html("Categorie (Salvare per visualizzare le categorie)");
  
    if ($('#languagePageSetting_seoTitle').val() == ''){
      $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
    }

      /*if ($('#languagePageSetting_SeoKeyword').val() == ''){
        $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
    }*/

      this.pageValueSelected.languagePageSetting.content = "";
      spinnerHelpers.show();
      var ln = this.pageValueSelected.languagePageSetting.idLanguage;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }

      var sUserId = storageData.sUserId();
      pageServices.getByUserDescription(sUserId, function(result){
     $.getScript( "https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function () {
      var searchParam = "";
      var initials = [];
      initials.push({
         id: result.data.idUser,
        text: result.data.userName
      });
      $('#user_id').html("");
      $('#user_id').val(result.data.idUser);
      $('#user_id').select2({
        data: initials,
        ajax: {
          url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
          data: function (params) {
            if(params.term==''){
              searchParam = '*';
            }else{
            searchParam = params.term;
            }
            var query = {
            search: searchParam
            }
            return query;
          },
          processResults: function (data) {
            var dataParse = JSON.parse(data);
            return {
              results: dataParse.data
            };
          }
        }
      });
    });
  });
 
      this.pageValueSelected = {
        id: 0,
        languagePageSetting: { content: '' },
        online: true,
        pageType: adminSettingNews.typePage,
      };
      this.pageValueSelected.languagePageSetting.idLanguage = ln;

      var data = new Date();
      var gg, mm, aaaa;
      gg = data.getDate() + "/";
      mm = data.getMonth() + 1 + "/";
      aaaa = data.getFullYear();

      var HH = data.getHours() + ":";
      var MM = data.getMinutes();
      var SS = data.getSeconds();
      parseInt(MM) < 10 ? MM = "0" + MM : null;
      parseInt(SS) < 10 ? SS = "0" + SS : null;

      $("#publish").val(gg+mm+aaaa + ' ' + HH+MM);
      $("#visibleFrom").val(gg+mm+aaaa + ' ' + HH+MM);

      $("#" + this.idTabAdminSettingNews).removeClass("active");
      $("#" + this.idTabNewNewsBody).addClass("active");

      spinnerHelpers.hide();
    },
    
    cancelNewNews() {
      var adminSettingNews = this;

        this.detailOrNew = false;

      adminSettingNews.titoloPagina = "";
      spinnerHelpers.show();
      var ln =
        adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      this.pageValueSelected = {
        id: 0,
        languagePageSetting: { content: null },
        online: true,
        pageType: adminSettingNews.typePage,
      };

      this.pageValueSelected.languagePageSetting.idLanguage = ln;
      
      $("#" + this.idTabAdminSettingNews).addClass("active");
      $("#" + this.idTabNewNewsBody).removeClass("active");
      spinnerHelpers.hide();
     // $("#user_id").val('');
      adminSettingNews.idUser = ''; 
    },

   getImage(page) {
    $("#modalImgBlogForm").modal("show"); 
    var adminSettingNews = this; 
    var data = {
      page : page,
      search : $('#modalImgBlogForm #search').val(),
      month : $('#modalImgBlogForm #month').val(),
      year : $('#modalImgBlogForm #year').val(),
    };

    pageServices.getByFile(data, function (result) {
      if(adminSettingNews.resultFilePopups.length == 0 || page == 1){
        adminSettingNews.resultFilePopups = result.data;
        $('#ul-image').css('max-height', window.innerHeight - 200);
      }else{
        var array1 = adminSettingNews.resultFilePopups;
        var array2 = result.data;
        var newArray = array1.concat(array2);
        adminSettingNews.resultFilePopups = newArray;
      }
    }); 
  },

  getImageShare(page) {
    $("#modalImgBlogFormShare").modal("show"); 
    var adminSettingNews = this; 
    var data = {
      page : page,
      search : $('#modalImgBlogFormShare #searchShare').val(),
      month : $('#modalImgBlogFormShare #monthShare').val(),
      year : $('#modalImgBlogFormShare #yearShare').val(),
    };

    pageServices.getByFile(data, function (result) {
      if(adminSettingNews.resultFilePopupsShare.length == 0 || page == 1){
        adminSettingNews.resultFilePopupsShare = result.data;
        $('#ul-image-share').css('max-height', window.innerHeight - 200);
      }else{
        var array1 = adminSettingNews.resultFilePopupsShare;
        var array2 = result.data;
        var newArray = array1.concat(array2);
        adminSettingNews.resultFilePopupsShare = newArray;
      }
    }); 
  },

    selectImg(img,imgName) {
    var adminSettingNews = this; 
    $("#modalImgBlogForm").modal("hide");
    adminSettingNews.pageValueSelected.languagePageSetting.urlCoverImage = img;
    adminSettingNews.pageValueSelected.languagePageSetting.imgName ='';
    adminSettingNews.img = img;
    },

    selectImgShare(img,imgName) {
    var adminSettingNews = this; 
    $("#modalImgBlogFormShare").modal("hide");
    adminSettingNews.pageValueSelected.languagePageSetting.urlShareImage = img;
    adminSettingNews.pageValueSelected.languagePageSetting.imgNameShare ='';
    adminSettingNews.img = img;
    },

    Search() { 
      var adminSettingNews = this;
      adminSettingNews.getImage(1);
    },
    SearchShare() { 
      var adminSettingNews = this;
      adminSettingNews.getImageShare(1);
    },


    SeoTitleFormatter (value, row, index, field){
    var adminSettingNews = this;
    var html = "";

  if (row.seotitle == '' || row.seotitle == null || row.seotitle == 'null' || row.seotitle == 0) {
      html +=
    '<p style="text-align: center;"><i class="fa fa-circle" title="Lunghezza Insufficiente" style="color:#FF0000; "aria-hidden="true"></i>' + '</p>'; 
  }else{
    if (row.seotitle.length >= 0 && row.seotitle.length <= 30){
        html +=
    '<p style="text-align: center;"><i class="fa fa-circle" title="Lunghezza Insufficiente" style="color:#FF0000; aria-hidden="true"></i>' + '</p>'; 
    }
    if (row.seotitle.length >= 31 && row.seotitle.length <= 60){
    html +=
    '<p style="text-align: center;"><i class="fa fa-circle" title="Lunghezza Corretta" style="color:#28D11B; aria-hidden="true"></i>' + '</p>'; 
    }
    if (row.seotitle.length >= 61 && row.seotitle.length <= 2000){
    html +=
    '<p style="text-align: center;"><i class="fa fa-circle" title="Lunghezza Eccessiva" style="color:#F8AF00; aria-hidden="true"></i>' + '</p>'; 
    }
}
    return html;
    },

 SeoDescriptionFormatter (value, row, index, field){
    var adminSettingNews = this;
    var html = "";
    if (row.seodescription == '' || row.seodescription == null || row.seodescription == 'null' || row.seodescription == 0) {
      html +=
    '<p style="text-align: center;"><i class="fa fa-circle" title="Lunghezza Insufficiente" style="color:#FF0000; "aria-hidden="true"></i>' + '</p>';  
  }else{
    if (row.seodescription.length >= 0 && row.seodescription.length <= 70){
        html +=
    '<p style="text-align: center;"><i class="fa fa-circle" title="Lunghezza Insufficiente" style="color:#FF0000; aria-hidden="true"></i>' + '</p>'; 
    }
    if (row.seodescription.length >= 71 && row.seodescription.length <= 155){
    html +=
    '<p style="text-align: center;"><i class="fa fa-circle"  title="Lunghezza Corretta"  style="color:#28D11B; aria-hidden="true"></i>' + '</p>';  
    }
    if (row.seodescription.length >= 156 && row.seodescription.length <= 2000){
    html +=
    '<p style="text-align: center;"><i class="fa fa-circle" title="Lunghezza Eccessiva"  style="color:#F8AF00; aria-hidden="true"></i>' + '</p>';  
    }
}
    return html;
    },
   
    tableFormatter(value, row, index, field) {
      var adminSettingNews = this;
      var html = "";
      html +=
        '<button class="btn btn-success" style="color:#fff;" onclick="adminSettingNews.__vue__.viewDetailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil" style="color:#fff;" title="' +
        this.openDetail +
        '" /></button>';
      html +=
        '<button class="btn btn-secondary" onclick="adminSettingNews.__vue__.previewClick(' +
        row.id +
        ',' + row.online + ')"><i class="fa fa-search" style="color:#fff;"/></button>';
      html +=
        '<button class="btn btn-info" onclick="adminSettingNews.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o" style="color:#fff;"/></button>';
      html +=
        '<button class="btn btn-danger" style="color:#fff;" onclick="adminSettingNews.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';
      (');"></i></div>');
      return html;
    },

    titleFormatter(value, row, index, field) {
      return row.title;
    },
    urlFormatter(value, row, index, field) {
      return row.url;
    },
    getPageCategory(id){
      var adminSettingNews = this;
      //TO DO 
      //1. funzione di prelievo elenco categorie pagina XX
      //2. inserimento result della webapi in array con json dentro descrizione categoria , booleano se la categoria è attiva XX
      //3. for in vue per visualizzazione grafica dell'elecon XX
      //4. funzione di onchange al check che aggiorna il dato booleano nello stesso array.
      //5. passaggio variabile al dataToSave.
      //6. implementazione funzione di salvataggio con passaggio dati di categoria 
      pageCategoryServices.getAllByPageId(id, function (result) {
        adminSettingNews.pageCategory = result.data;
      });
    },
    handleScroll(){
      if($('#ul-image').scrollTop() + $('#ul-image').innerHeight() >= $('#ul-image')[0].scrollHeight) {
        this.getImage(this.pageImage + 1);
        this.pageImage = this.pageImage + 1;
      }
    },
    handleScrollShare(){
      if($('#ul-image-share').scrollTop() + $('#ul-image-share').innerHeight() >= $('#ul-image-share')[0].scrollHeight) {
        this.getImageShare(this.pageImageShare + 1);
        this.pageImageShare = this.pageImageShare + 1;
      }
    },
    updatePageCategory(id){
      var adminSettingNews = this;
      //aggiornamento array ciclato che poi verrà passato alla webapi di salvataggio 
      for(var i = 0; i < adminSettingNews.pageCategory.length; i++){
        if(adminSettingNews.pageCategory[i].id == id){
          if($("#checkboxPageCategories" + id).is(':checked')){
            adminSettingNews.pageCategory[i].active = true;
          }else{
            adminSettingNews.pageCategory[i].active = false;
          }
        }
      }
    },
    viewDetailInfo(id) {
      var adminSettingNews = this;
      this.detailOrNew = true;

      spinnerHelpers.show();
      adminSettingNews.getPageCategory(id);
      var sUserId = storageData.sUserId();

        var ln = storageData.sIdLanguage();
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }

          pageCategoryServices.getAllListCategories(ln, id, function (result) {
          adminSettingNews.listTreeCategories = result.data;
          spinnerHelpers.hide();
        });

    pageServices.getSetting(id,sUserId, function (result) {
    $.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function(){ 
      var searchParam = ""; 
        var initialss = [];
  // if (result.data.IdUser != 'null' || result.data.IdUser != null || result.data.IdUser != '') { 
        initialss.push({
          id: result.data.idUser,
          text: result.data.userName
        });
    //}  
    $('#user_id').html("");
      $('#user_id').val(result.data.idUser);
        $('#user_id').select2({
          data: initialss,
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
            data: function (params) {
              if(params.term==''){
                searchParam = '*';
              }else{
              searchParam = params.term;  
              }                      
              var query = {
              search: searchParam 
              }          
              return query;        
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);        
              return {
                results: dataParse.data
              };  
            }
          }
        });

     var searchParam = ""; 
        var initials = [];
        $('#user_id').select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
            data: function (params) {
              if(params.term==''){
                searchParam = '*';
              }else{
              searchParam = params.term;  
              }                      
              var query = {
              search: searchParam 
              }          
              return query;        
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);        
              return {
                results: dataParse.data
              };  
            }
          }
        });
    });
        adminSettingNews.pageValueOriginal = dataHelpers.unbind(result.data);
        adminSettingNews.pageValueDataToSave = dataHelpers.unbind(result.data.languagePageSetting);
        adminSettingNews.titoloPagina = result.data.languagePageSetting[0].title;
        adminSettingNews.setDataPage(dataHelpers.unbind(result.data));
  
   var SeotitleToTitles = result.data.languagePageSetting[0].seoTitle;
 
   if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
    }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((87 * SeotitleToTitles.length)/30) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((87 * SeotitleToTitles.length)/60) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((87 * SeotitleToTitles.length)/1000) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }

  var seoDescriptiontoShareDescription = result.data.languagePageSetting[0].seoDescription;
  if (seoDescriptiontoShareDescription == '' || seoDescriptiontoShareDescription == null || seoDescriptiontoShareDescription == 'null' || seoDescriptiontoShareDescription == 0) {
      var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoDescription_feedback').remove();
        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
  }else{
    if (seoDescriptiontoShareDescription.length >= 0 && seoDescriptiontoShareDescription.length <= 70){
            var d = ((87 * seoDescriptiontoShareDescription.length)/70) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
        }

        if (seoDescriptiontoShareDescription.length >= 71 && seoDescriptiontoShareDescription.length <= 155){
            var d = ((87 * seoDescriptiontoShareDescription.length)/155) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -126px;left: 13px;"></div>')
        }

        if (seoDescriptiontoShareDescription.length >= 156 && seoDescriptiontoShareDescription.length <= 2000){
            var d = ((87 * seoDescriptiontoShareDescription.length)/2000) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -126px;left: 13px;"></div>')
        }
  }

    /*  var seoKeyword = result.data.languagePageSetting[0].seoKeyword;
            if (seoKeyword == '' || seoKeyword == null || seoKeyword == 'null' || seoKeyword == 0) {
              var d = ((87 * 10)/100) + "%";
                $('#languagePageSetting_SeoKeyword_feedback').remove();
                $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
            }else{
              if (seoKeyword.length >= 0 && seoKeyword.length <= 30){
                  var d = ((87 * seoKeyword.length)/30) + "%";
                  $('#languagePageSetting_SeoKeyword_feedback').remove();
                  $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
              }

              if (seoKeyword.length >= 30 && seoKeyword.length <= 60){
                  var d = ((87 * seoKeyword.length)/60) + "%";
                  $('#languagePageSetting_SeoKeyword_feedback').remove();
                  $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
              }

              if (seoKeyword.length >= 60 && seoKeyword.length <= 1000){
                  var d = ((87 * seoKeyword.length)/1000) + "%";
                  $('#languagePageSetting_SeoKeyword_feedback').remove();
                  $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
              }
            }*/

  });   
      $("#" + adminSettingNews.idTabAdminSettingNews).removeClass("active");
      $("#" + adminSettingNews.idTabNewNewsBody).addClass("active");
      spinnerHelpers.hide();
    },



    checkCategoriesClick(id, checkedCategories) {
      var adminSettingNews = this;

      var data = {
        idCategories: id,
        idPages: adminSettingNews.pageValueSelected.id,
      };

      if (checkedCategories) {
          pageServices.insertItemCategoriesPages(data, function (result) {
            notificationHelpers.success("Articolo aggiunto alla categoria selezionata");
          });
      } else {
          pageServices.deleteItemCategoriesPages(id, adminSettingNews.pageValueSelected.id, function (result) {
            notificationHelpers.success("Articolo rimosso dalla categoria selezionata");
          }
        );
      }
    },

    setDataPage(data) {
      var adminSettingNews = this;

      adminSettingNews.img = data.languagePageSetting.urlCoverImage;
      adminSettingNews.pageValueSelected = data;
      $.each(
        dataHelpers.unbind(
          adminSettingNews.pageValueOriginal.languagePageSetting
        ),
        function (i, languagePageSetting) {
          if (
            languagePageSetting.idLanguage == adminSettingNews.$refs.select_AdminPagesView_IdLanguage.value
          ) {
            adminSettingNews.pageValueSelected.languagePageSetting = languagePageSetting;
            return;
          }
        }
      );
    },
    previewClick(id, online) {
      var sUserId = storageData.sUserId();
      pageServices.getSetting(id,sUserId, function (result) {
        if(online){
          window.open(result.data.languagePageSetting[0].url);
        }else{
          window.open(result.data.languagePageSetting[0].url + '_preview');
        }
      });   
    },

    changeView: function (event) {
      var adminSettingNews = this;
      var id = event && event.target && event.target.id ? event.target.id : "";

      switch (id) {
        case "btnSettingAdminPagesView":
          adminSettingNews.pageToView = "settings";
          break;
        default:
          adminSettingNews.pageToView = "content";
          break;
      }
    },
    changeSeoDescription(field, value) {
    var adminSettingNews = this;     
    var seoDescriptiontoShareDescription = $('#languagePageSetting\\.seoDescription').val();

       if (seoDescriptiontoShareDescription == '' || seoDescriptiontoShareDescription == null || seoDescriptiontoShareDescription == 'null' || seoDescriptiontoShareDescription == 0) {
      var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoDescription_feedback').remove();
        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
  }else{
    if (seoDescriptiontoShareDescription.length >= 0 && seoDescriptiontoShareDescription.length <= 70){
            var d = ((87 * seoDescriptiontoShareDescription.length)/70) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
        }

        if (seoDescriptiontoShareDescription.length >= 71 && seoDescriptiontoShareDescription.length <= 155){
            var d = ((87 * seoDescriptiontoShareDescription.length)/155) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -126px;left: 13px;"></div>')
        }

        if (seoDescriptiontoShareDescription.length >= 156 && seoDescriptiontoShareDescription.length <= 2000){
            var d = ((87 * seoDescriptiontoShareDescription.length)/2000) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -126px;left: 13px;"></div>')
        }
  }

    },

  keyupSeoTitle(field, value) {
  var adminSettingNews = this;

  var SeotitleToTitles= $("#languagePageSetting_seoTitle").val();
  
  if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((87 * SeotitleToTitles.length)/30) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((87 * SeotitleToTitles.length)/60) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((87 * SeotitleToTitles.length)/1000) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }
  },

 
  /*  keyupSeoKeyword(field, value) {
    var adminSettingNews = this;     
    var languagePageSetting_SeoKeyword = $('#languagePageSetting_SeoKeyword').val();

    if (languagePageSetting_SeoKeyword == '' || languagePageSetting_SeoKeyword == null || languagePageSetting_SeoKeyword == 'null' || languagePageSetting_SeoKeyword == 0) {
        var d = ((87 * 10)/100) + "%";
          $('#languagePageSetting_SeoKeyword_feedback').remove();
          $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
    }else{
      if (languagePageSetting_SeoKeyword.length >= 0 && languagePageSetting_SeoKeyword.length <= 30){
              var d = ((87 * languagePageSetting_SeoKeyword.length)/30) + "%";
              $('#languagePageSetting_SeoKeyword_feedback').remove();
              $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
          }
          if (languagePageSetting_SeoKeyword.length >= 31 && languagePageSetting_SeoKeyword.length <= 60){
              var d = ((87 * languagePageSetting_SeoKeyword.length)/60) + "%";
              $('#languagePageSetting_SeoKeyword_feedback').remove();
              $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
          }
          if (languagePageSetting_SeoKeyword.length >= 61 && languagePageSetting_SeoKeyword.length <= 1000){
              var d = ((87 * languagePageSetting_SeoKeyword.length)/1000) + "%";
              $('#languagePageSetting_SeoKeyword_feedback').remove();
              $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
          }
      }
  },*/


  keyupSeoDescription(field, value) {
  var adminSettingNews = this;     
      var seoDescriptiontoShareDescription = $('#languagePageSetting\\.seoDescription').val();

  if (seoDescriptiontoShareDescription == '' || seoDescriptiontoShareDescription == null || seoDescriptiontoShareDescription == 'null' || seoDescriptiontoShareDescription == 0) {
      var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoDescription_feedback').remove();
        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
  }else{
    if (seoDescriptiontoShareDescription.length >= 0 && seoDescriptiontoShareDescription.length <= 70){
            var d = ((87 * seoDescriptiontoShareDescription.length)/70) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
        }

        if (seoDescriptiontoShareDescription.length >= 71 && seoDescriptiontoShareDescription.length <= 155){
            var d = ((87 * seoDescriptiontoShareDescription.length)/155) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -126px;left: 13px;"></div>')
        }

        if (seoDescriptiontoShareDescription.length >= 156 && seoDescriptiontoShareDescription.length <= 2000){
            var d = ((87 * seoDescriptiontoShareDescription.length)/2000) + "%";
            $('#languagePageSetting_seoDescription_feedback').remove();
            $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -126px;left: 13px;"></div>')
        }
  }
  },

  changeSeoTitle(field, value) {
      var adminSettingNews = this;

      var SeotitleToTitles= $("#languagePageSetting_seoTitle").val();
        if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
  }else{
   if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((87 * SeotitleToTitles.length)/30) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
      }
     if (SeotitleToTitles.length >= 31 && SeotitleToTitles.length <= 60){
        var d = ((87 * SeotitleToTitles.length)/60) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length >= 61 && SeotitleToTitles.length <= 1000){
        var d = ((87 * SeotitleToTitles.length)/1000) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }
  },

    changeTitle(field, value) {
      var adminSettingNews = this;
      var titleToTitles= $("#languagePageSetting_title").val();

      var cleanShareTitle = titleToTitles;  
      if (adminSettingNews.pageValueSelected.id == null || $("#languagePageSetting_shareTitle").val() == "") {
        $("#languagePageSetting_shareTitle").val(cleanShareTitle);
        adminSettingNews.pageValueSelected.languagePageSetting.shareTitle = dataHelpers.unbind(cleanShareTitle);
      }

      //copy url
      var titleToUrl = $("#languagePageSetting_title").val(),
      cleanUrl = "";
      cleanUrl =
        "/" +
        adminSettingNews.typePage.toLowerCase() +
        "/" +
        titleToUrl
          .replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-")    
          .replace(/([\à\s])/g, "a")
          .replace(/([\á\s])/g, "a")
          .replace(/([\è\s])/g, "e")
          .replace(/([\ê\s])/g, "e")
          .replace(/([\é\s])/g, "e")
          .replace(/([\ì\s])/g, "i")
          .replace(/([\í\s])/g, "i")
          .replace(/([\ò\s])/g, "o")
          .replace(/([\ó\s])/g, "o")
          .replace(/([\ù\s])/g, "u")
          .replace(/([\ú\s])/g, "u")
          .replace(/([\ż\s])/g, "z")
          .replace(/([\ź\s])/g, "z")
         	.replace(/([\ź\s])/g, "z")
          .replace(/([\ń\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")  
          .toLowerCase();

      for (var i=0; i<100; i++){
        if (cleanUrl.includes('--')) { 
          cleanUrl = cleanUrl.replace('--', '-');
        }else{
          break;
        } 
      }

        var myString = cleanUrl;
        var stringLength = myString.length;
        var lastChar = myString.charAt(stringLength - 1);

        if (lastChar == '-') {
           var cleanUrl = myString.substring(0, myString.length - 1); 
            $("#languagePageSetting_url").val(cleanUrl);
            $("#languagePageSetting_urlCanonical").val(cleanUrl);
        }
          
      if (adminSettingNews.pageValueSelected.id == null || $("#languagePageSetting_url").val() == "") {  
        $("#languagePageSetting_url").val(cleanUrl);
        $("#languagePageSetting_urlCanonical").val(cleanUrl);
        adminSettingNews.pageValueSelected.languagePageSetting.url = dataHelpers.unbind(cleanUrl);
    }
        this.checkUrl(cleanUrl);   
    },

    checkUrl(url) {
      if (url == "languagePageSetting_url") {
        url = $("#" + url).val(); 
      }
      var adminSettingNews = this;
      if (adminSettingNews.showBtnContentAdminPagesView) {
        if (adminSettingNews.pageValueSelected.id == null) {
          pageServices.checkExistUrl(url, function (result) {
            if (result.data) {
              notificationHelpers.error(
                dictionaryHelpers.getDictionary("UrlAlreadyExist")
              );
              validationHelpers.setDetailError(
                "languagePageSetting_url",
                dictionaryHelpers.getDictionary("UrlAlreadyExist")
              );
            } else {
              $("#languagePageSetting_url").removeClass("error");
              validationHelpers.clear("#frmAdminPages");
            }
          });
        } else {
          pageServices.checkExistUrlNotForThisPage(
            url,
            adminSettingNews.pageValueSelected.id,
            function (result) {
              if (result.data) {
                notificationHelpers.error(
                  dictionaryHelpers.getDictionary("UrlAlreadyExist")
                );
                validationHelpers.setDetailError(
                  "languagePageSetting_url",
                  dictionaryHelpers.getDictionary("UrlAlreadyExist")
                );
              } else {
                $("#languagePageSetting_url").removeClass("error");
                validationHelpers.clear("#frmAdminPages");
              }
            }
          );
        }
      }
    },
    savePage() {
      if (validationHelpers.isValid("#frmadminSettingNews")) {
        spinnerHelpers.show();
        var adminSettingNews = this;
  
        var dataToSave = adminSettingNews.dataToSave();
        
        if (dataToSave.languagePageSetting[0].url.includes("!") || 
        dataToSave.languagePageSetting[0].url.includes("?") || dataToSave.languagePageSetting[0].url.includes("%")||
       
        dataToSave.languagePageSetting[0].url.includes("^") || dataToSave.languagePageSetting[0].url.includes("$") ||
        dataToSave.languagePageSetting[0].url.includes("*") || dataToSave.languagePageSetting[0].url.includes(".") ||
        dataToSave.languagePageSetting[0].url.includes("÷") || dataToSave.languagePageSetting[0].url.includes("±") ||
        dataToSave.languagePageSetting[0].url.includes("°") || dataToSave.languagePageSetting[0].url.includes("@") ||
        dataToSave.languagePageSetting[0].url.includes(":") || dataToSave.languagePageSetting[0].url.includes("§") ||
        dataToSave.languagePageSetting[0].url.includes(":") || dataToSave.languagePageSetting[0].url.includes("§") ||
        dataToSave.languagePageSetting[0].url.includes(";") || dataToSave.languagePageSetting[0].url.includes("#") ||
        dataToSave.languagePageSetting[0].url.includes("'") || dataToSave.languagePageSetting[0].url.includes("£") ||
        dataToSave.languagePageSetting[0].url.includes('"') || dataToSave.languagePageSetting[0].url.includes("&") ||
        dataToSave.languagePageSetting[0].url.includes("=") || dataToSave.languagePageSetting[0].url.includes("€") ||
        dataToSave.languagePageSetting[0].url.includes(">") || dataToSave.languagePageSetting[0].url.includes("<") ||
        dataToSave.languagePageSetting[0].url.includes("¿") || dataToSave.languagePageSetting[0].url.includes("¶") ||
        dataToSave.languagePageSetting[0].url.includes("~") || dataToSave.languagePageSetting[0].url.includes("«") ||
        dataToSave.languagePageSetting[0].url.includes("¢") || dataToSave.languagePageSetting[0].url.includes("ß") ||
        dataToSave.languagePageSetting[0].url.includes("¥") || dataToSave.languagePageSetting[0].url.includes("©") ||
        dataToSave.languagePageSetting[0].url.includes("|") || dataToSave.languagePageSetting[0].url.includes("®") ||
        dataToSave.languagePageSetting[0].url.includes("+") || dataToSave.languagePageSetting[0].url.includes("-") ||
        dataToSave.languagePageSetting[0].url.includes("™") || dataToSave.languagePageSetting[0].url.includes("}") ||
        dataToSave.languagePageSetting[0].url.includes("{") || dataToSave.languagePageSetting[0].url.includes("]") ||
        dataToSave.languagePageSetting[0].url.includes("[")  
        ){
          dataToSave.languagePageSetting[0].url =  dataToSave.languagePageSetting[0].url.replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-");   
        }
         if (dataToSave.languagePageSetting[0].url.includes("à") ||
            dataToSave.languagePageSetting[0].url.includes("á") ||
            dataToSave.languagePageSetting[0].url.includes("è") ||
            dataToSave.languagePageSetting[0].url.includes("ê") ||
            dataToSave.languagePageSetting[0].url.includes("é") ||
            dataToSave.languagePageSetting[0].url.includes("ì") ||
            dataToSave.languagePageSetting[0].url.includes("í") ||
            dataToSave.languagePageSetting[0].url.includes("ò") ||
            dataToSave.languagePageSetting[0].url.includes("ó") ||
            dataToSave.languagePageSetting[0].url.includes("ù") ||
            dataToSave.languagePageSetting[0].url.includes("ú") 
            ){ 
            dataToSave.languagePageSetting[0].url =  dataToSave.languagePageSetting[0].url
            .replace(/([\à\s])/g, "a")  
            .replace(/([\á\s])/g, "a")
            .replace(/([\è\s])/g, "e")
            .replace(/([\ê\s])/g, "e")
            .replace(/([\é\s])/g, "e")
            .replace(/([\ì\s])/g, "i")
            .replace(/([\í\s])/g, "i")
            .replace(/([\ò\s])/g, "o")
            .replace(/([\ó\s])/g, "o")
            .replace(/([\ù\s])/g, "u")
            .replace(/([\ú\s])/g, "u");
        }    
        if (adminSettingNews.pageValueSelected.id == 0 || !functionHelpers.isValued(adminSettingNews.pageValueSelected.id)) {
          pageServices.insert(dataToSave, function (result) {
            var ln = adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
            var id = result.data;
                  $('#titlePageTabPublication').html("Categorie");

              adminSettingNews.viewDetailInfo(id);
              notificationHelpers.success(dictionaryHelpers.getDictionary("InsertCompleted"));

            if (!functionHelpers.isValued(ln)) {
              ln = storageData.sIdLanguage();
            }
              adminSettingNews.loadTableData();
           /* $("#" + adminSettingNews.idTabNewNewsBody).addClass("active");
            $("#" + adminSettingNews.idTabAdminSettingNews).removeClass("active");*/
            spinnerHelpers.hide();
            window.scrollTo(0, 0);
          });
        } else {
        //(dataToSave);
          pageServices.update(dataToSave, function () {
            notificationHelpers.success(dictionaryHelpers.getDictionary("UpdateCompleted"));
            adminSettingNews.idUser = ''; 
            var ln =
              adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
            if (!functionHelpers.isValued(ln)) {
              ln = storageData.sIdLanguage();
            }
            $("#" + adminSettingNews.idTabNewNewsBody).addClass("active");
            $("#" + adminSettingNews.idTabAdminSettingNews).removeClass("active"); 
            spinnerHelpers.hide();
            window.scrollTo(0, 0);
          });
        }
      }
    },

  savePageAndExit() {
      if (validationHelpers.isValid("#frmadminSettingNews")) {
        spinnerHelpers.show();
        var adminSettingNews = this;
        this.detailOrNew = false;

       adminSettingNews.titoloPagina = "";

        var dataToSave = adminSettingNews.dataToSave();       
        if (dataToSave.languagePageSetting[0].url.includes("!") || 
        dataToSave.languagePageSetting[0].url.includes("?") || dataToSave.languagePageSetting[0].url.includes("%")||       
        dataToSave.languagePageSetting[0].url.includes("^") || dataToSave.languagePageSetting[0].url.includes("$") ||
        dataToSave.languagePageSetting[0].url.includes("*") || dataToSave.languagePageSetting[0].url.includes(".") ||
        dataToSave.languagePageSetting[0].url.includes("÷") || dataToSave.languagePageSetting[0].url.includes("±") ||
        dataToSave.languagePageSetting[0].url.includes("°") || dataToSave.languagePageSetting[0].url.includes("@") ||
        dataToSave.languagePageSetting[0].url.includes(":") || dataToSave.languagePageSetting[0].url.includes("§") ||
        dataToSave.languagePageSetting[0].url.includes(":") || dataToSave.languagePageSetting[0].url.includes("§") ||
        dataToSave.languagePageSetting[0].url.includes(";") || dataToSave.languagePageSetting[0].url.includes("#") ||
        dataToSave.languagePageSetting[0].url.includes("'") || dataToSave.languagePageSetting[0].url.includes("£") ||
        dataToSave.languagePageSetting[0].url.includes('"') || dataToSave.languagePageSetting[0].url.includes("&") ||
        dataToSave.languagePageSetting[0].url.includes("=") || dataToSave.languagePageSetting[0].url.includes("€") ||
        dataToSave.languagePageSetting[0].url.includes(">") || dataToSave.languagePageSetting[0].url.includes("<") ||
        dataToSave.languagePageSetting[0].url.includes("¿") || dataToSave.languagePageSetting[0].url.includes("¶") ||
        dataToSave.languagePageSetting[0].url.includes("~") || dataToSave.languagePageSetting[0].url.includes("«") ||
        dataToSave.languagePageSetting[0].url.includes("¢") || dataToSave.languagePageSetting[0].url.includes("ß") ||
        dataToSave.languagePageSetting[0].url.includes("¥") || dataToSave.languagePageSetting[0].url.includes("©") ||
        dataToSave.languagePageSetting[0].url.includes("|") || dataToSave.languagePageSetting[0].url.includes("®") ||
        dataToSave.languagePageSetting[0].url.includes("+") || dataToSave.languagePageSetting[0].url.includes("-") ||
        dataToSave.languagePageSetting[0].url.includes("™") || dataToSave.languagePageSetting[0].url.includes("}") ||
        dataToSave.languagePageSetting[0].url.includes("{") || dataToSave.languagePageSetting[0].url.includes("]") ||
        dataToSave.languagePageSetting[0].url.includes("[")  
        ){
          dataToSave.languagePageSetting[0].url =  dataToSave.languagePageSetting[0].url.replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-");   
        }

         if (dataToSave.languagePageSetting[0].url.includes("à") ||
            dataToSave.languagePageSetting[0].url.includes("á") ||
            dataToSave.languagePageSetting[0].url.includes("è") ||
            dataToSave.languagePageSetting[0].url.includes("ê") ||
            dataToSave.languagePageSetting[0].url.includes("é") ||
            dataToSave.languagePageSetting[0].url.includes("ì") ||
            dataToSave.languagePageSetting[0].url.includes("í") ||
            dataToSave.languagePageSetting[0].url.includes("ò") ||
            dataToSave.languagePageSetting[0].url.includes("ó") ||
            dataToSave.languagePageSetting[0].url.includes("ù") ||
            dataToSave.languagePageSetting[0].url.includes("ú") 
            ){ 
            dataToSave.languagePageSetting[0].url =  dataToSave.languagePageSetting[0].url
            .replace(/([\à\s])/g, "a")  
            .replace(/([\á\s])/g, "a")
            .replace(/([\è\s])/g, "e")
            .replace(/([\ê\s])/g, "e")
            .replace(/([\é\s])/g, "e")
            .replace(/([\ì\s])/g, "i")
            .replace(/([\í\s])/g, "i")
            .replace(/([\ò\s])/g, "o")
            .replace(/([\ó\s])/g, "o")
            .replace(/([\ù\s])/g, "u")
            .replace(/([\ú\s])/g, "u");
        }
        if (adminSettingNews.pageValueSelected.id == 0 || !functionHelpers.isValued(adminSettingNews.pageValueSelected.id)) {
          pageServices.insert(dataToSave, function (result) {
            notificationHelpers.success(dictionaryHelpers.getDictionary("InsertCompleted"));
            var ln = adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
            if (!functionHelpers.isValued(ln)) {
              ln = storageData.sIdLanguage();
            }
            adminSettingNews.loadTableData(ln, adminSettingNews.typePage);
            $("#" + adminSettingNews.idTabAdminSettingNews).addClass("active");
            $("#" + adminSettingNews.idTabNewNewsBody).removeClass("active");
            window.scrollTo(0, 0);
          });
        } else {
        //(dataToSave);
          pageServices.update(dataToSave, function () {
            notificationHelpers.success(dictionaryHelpers.getDictionary("UpdateCompleted"));
            adminSettingNews.idUser = ''; 
            var ln =
              adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
            if (!functionHelpers.isValued(ln)) {
              ln = storageData.sIdLanguage();
            }
            adminSettingNews.loadTableData(ln, adminSettingNews.typePage);
            $("#" + adminSettingNews.idTabAdminSettingNews).addClass("active");
            $("#" + adminSettingNews.idTabNewNewsBody).removeClass("active");

            window.scrollTo(0, 0);
          });
        }
      }
    },

    dataToSave(publish) {
      var adminSettingNews = this;
      var dataToSave = {};
      
      var languageFound = false;
      $.each(adminSettingNews.pageValueDataToSave, function (i, dataToSave) {
        if (
          dataToSave.idLanguage ==
          adminSettingNews.pageValueSelected.languagePageSetting.idLanguage
        ) {
          adminSettingNews.pageValueDataToSave[i] = dataHelpers.unbind(
            adminSettingNews.pageValueSelected.languagePageSetting
          );
          languageFound = true;
        }
      });

      if (!languageFound) {
        var i = 0;
        if (
          functionHelpers.isValued(adminSettingNews.pageValueDataToSave.length)
        ) {
          i = adminSettingNews.pageValueDataToSave.length;
        }
        adminSettingNews.pageValueDataToSave[i] = dataHelpers.unbind(
          adminSettingNews.pageValueSelected.languagePageSetting
        );
      }
      $.each(adminSettingNews.pageValueSelected, function (field, value) {
        switch (field) {
          case "languagePageSetting":
            dataToSave[field] = adminSettingNews.pageValueDataToSave;
            break;
          default:
            dataToSave[field] = configurationHelpers.getValueToSave(
              value,
              adminSettingNews.getFieldType(field)
            );
            break;
        }
      });

      dataToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
      dataToSave.pageCategory = adminSettingNews.pageCategory;
      dataToSave.idUser = $("#user_id").val();

      return dataToSave;
    },
    getFieldType(field) {
      var adminSettingNews = this;
      var result;

      $.each(adminSettingNews.configurationsSelected, function (i, config) {
        if (config.field == field) {
          result = config.inputType;
          return false;
        }
      });

      return result;
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminSettingNews = this;

      if (
        functionHelpers.isValued(adminSettingNews.pageValueSelected) &&
        adminSettingNews.pageValueSelected.languagePageSetting.idLanguage !=
          value
      ) {
        // Save data
        var languageFound = false;

        $.each(adminSettingNews.pageValueDataToSave, function (i, dataToSave) {
          if (
            dataToSave.idLanguage ==
            adminSettingNews.pageValueSelected.languagePageSetting.idLanguage
          ) {
            adminSettingNews.pageValueDataToSave[i] = dataHelpers.unbind(
              adminSettingNews.pageValueSelected.languagePageSetting
            );
            languageFound = true;
          }
        });

        if (!languageFound) {
          var i = 0;
          if (
            functionHelpers.isValued(
              adminSettingNews.pageValueDataToSave.length
            )
          ) {
            i = adminSettingNews.pageValueDataToSave.length;
          }
          adminSettingNews.pageValueDataToSave[i] = dataHelpers.unbind(
            adminSettingNews.pageValueSelected.languagePageSetting
          );
        }

        languageFound = false;
        // Set data from save data
        $.each(adminSettingNews.pageValueDataToSave, function (i, dataToSave) {
          if (dataToSave.idLanguage == value) {
            adminSettingNews.pageValueSelected.languagePageSetting = dataHelpers.unbind(
              dataToSave
            );
            languageFound = true;
          }
        });

        if (!languageFound) {
          $.each(
            adminSettingNews.pageValueSelected.languagePageSetting,
            function (fieldKey, fieldValue) {
              switch (fieldKey) {
                case "idLanguage":
                  adminSettingNews.pageValueSelected.languagePageSetting[
                    fieldKey
                  ] = Number(value);
                  break;
                default:
                  adminSettingNews.pageValueSelected.languagePageSetting[
                    fieldKey
                  ] = null;
                  break;
              }
            }
          );
        }
      }
      var pageTypeList = adminSettingNews.pageValueSelected.pageType;
      adminSettingNews.loadTableData(value, pageTypeList);

      spinnerHelpers.hide();
    },

    clone(id) {
      var adminSettingNews = this;
      spinnerHelpers.show();
      pageServices.clone(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
        var ln =
          adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminSettingNews.loadTableData(ln, adminSettingNews.typePage);
      });
    },

    delete(id) {
      var adminSettingNews = this;
      if (confirm("Vuoi eliminare il blog?")) {
        adminSettingNews.executeCancelData(id);
      }
    },

    executeCancelData(id) {
      var adminSettingNews = this;
      adminSettingNews.detailOrNew = false;
      adminSettingNews.titoloPagina = "";
      spinnerHelpers.show();
      pageServices.del(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
      
        var ln =
          adminSettingNews.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminSettingNews.loadTableData(ln, adminSettingNews.typePage);
        window.scrollTo(0, 0);
      });
     
    },
    updateContenuto(value) {
      this.pageValueSelected.languagePageSetting.content = value;
    },
  },
};
</script>
<style scoped>

.card-title-admin .card {
  background: transparent;
  border: 0px;
}
.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}
#accordion .card-header h5 button {
  color: #fff;
  font-weight: bold;
  letter-spacing: .5px;
  display:inline;
  text-transform: uppercase;
}
#accordion .card-header .fa {
  color: #fff;
}
.align-btns {
 position: absolute;
    z-index: 1;
    margin-top: 7px;
}

#tabNewsBody {
    margin-top: -7px;
}

.select2 {
  width: 100%;
  height: 34px;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #5c6873;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e4e7ea;
  border-radius: 0.25rem;
}
.span-language {
  margin-left: 225px;
  margin-right: 152px;
  margin-top: -25px;
  position: absolute;
}
#accordion .card-header{
  background:#2A3545 !important;
  border-bottom:3px solid #f45f00 !important;
}

#accordion .card-header h5 button{
  color:#fff;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  margin-top:7px;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
 margin-top:8px;
}

#imgAggUpload[type="file"] {
  display: none;
}

.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  text-align: center;
  font-weight: lighter;
  border: 3px dashed #ededed;
  border-radius: 10px;
  color: slategrey;
}

.contPreviewImage {
  padding: 15px;
  margin: 2px;
  border: 2px solid #ededed;
  cursor: pointer;
}

.modal{
    margin-left: 6px;
    padding: 7px;
}

#col-form-label {
    color: rgba(0,0,0,.6);
    font-size: 12px;
    font-weight: lighter;
    margin-bottom: -15px;
    min-height: 15px;
    max-height: 15px;
}

#pageTabPublicationCat{
  padding-left: 10px;
  border: 1px solid #ededed;
  overflow-y: auto;
  padding-right: 20px;
  max-height: 300px;
  padding-top:10px;
  margin-bottom: 2rem;
}

.labelPageCategories{
  margin-bottom:0.2rem;
  font-weight:300px;
  display: inline;
}
#titlePageTabPublication{
  margin-top: -21px;
  position: absolute;
  background: #fff; 
  font-weight:300px; 
}
.checkboxPageCategories{
  margin-right:5px; 
}

.list-group-item{
  margin-bottom: 5px;
  height: 105px;
  padding: 0px;
  background: #ededed;
  border-radius: 0px;
}

#ul-image{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
#ul-image-share{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
.listLi {
  list-style: none;
  text-align: center;
}
.labelListImage {
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 0px !important;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: rgba(255,255,255,0.7);
}
.modal-dialo{
  /*margin-left: calc(1vw);*/
  padding: 7px;
  width: calc(98vw);
  height: calc(99vh);
}

.popup{
height:100%;
}

.div-extension-img{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: #238AE6;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    box-shadow: 0px 0px 7px -2px rgb(0 0 0 / 30%);
}

.div-extension-img label {
    font-size: 10px;
    margin: 0px !important;
    display: block;
    color: #fff;
    font-weight: bold;
}

   

</style>